// extracted by mini-css-extract-plugin
export default {"tabs":"CustomizePageTabSection-module_tabs__yowtR","tabpanel":"CustomizePageTabSection-module_tabpanel__L1v21"};